const SET_LIST = 'SET_LIST';
const SET_ACTIVE_RECORD = 'SET_ACTIVE_RECORD';

const state = {
  list: [],
  activeRecord: null,
  status: null,
};

const getters = {
  list: state => state.list,
  activeRecord: state => state.activeRecord,
};

const actions = {
  setList({dispatch, commit}, payload) {
    commit(SET_LIST, payload);
  },
  setActiveRecord({dispatch, commit}, payload) {
    commit(SET_ACTIVE_RECORD, payload);
  },
};

const mutations = {
  [SET_LIST](state, payload) {
    state.list = payload;
  },
  [SET_ACTIVE_RECORD](state, payload) {
    state.activeRecord = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
